// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1WVAh","title":"Header_title__DhcXt","left":"Header_left__O0nZU","clinicName":"Header_clinicName__3y9-h"};